import produce from 'immer';
import {
  SYSTEM_API_ROEL_DELETE_REQUEST,
  SYSTEM_API_ROEL_UPDATE_REQUEST,
  SYSTEM_API_ROLE_LIST_REQUEST
} from '../../constants/backoffice/systemConstants';

const initialState = {
  list : null,
};

const systemReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case SYSTEM_API_ROLE_LIST_REQUEST:
      draft.list = action.list
      break;

    case SYSTEM_API_ROEL_UPDATE_REQUEST:
      break;

    case SYSTEM_API_ROEL_DELETE_REQUEST:
      break;

    default:
      break;
  }
});

export default systemReducer;
